/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendLeadReferralResponse
 */
export interface SendLeadReferralResponse {
    /**
     * ULID of the sent referral
     */
    referral_id: string;
}

/**
 * Check if a given object implements the SendLeadReferralResponse interface.
 */
export function instanceOfSendLeadReferralResponse(value: object): value is SendLeadReferralResponse {
    if (!('referral_id' in value) || value['referral_id'] === undefined) return false;
    return true;
}

export function SendLeadReferralResponseFromJSON(json: any): SendLeadReferralResponse {
    return SendLeadReferralResponseFromJSONTyped(json, false);
}

export function SendLeadReferralResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendLeadReferralResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'referral_id': json['referral_id'],
    };
}

export function SendLeadReferralResponseToJSON(json: any): SendLeadReferralResponse {
    return SendLeadReferralResponseToJSONTyped(json, false);
}

export function SendLeadReferralResponseToJSONTyped(value?: SendLeadReferralResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referral_id': value['referral_id'],
    };
}

